import React from 'react'
import {
    Card,
    ContentData,
    ContentIcons,
    ContentSection,
    HeaderCard,
    Image,
    OverCard,
    TitleSection,
    Icon,
} from './styles'
import { SuccessLabels } from 'src/types'
import android from 'src/assets/SuccessStories/android.avif'
import apple from 'src/assets/SuccessStories/apple.avif'
import web from 'src/assets/SuccessStories/web.avif'

export const MapCard = ({
    firstImage,
    title,
    functionality,
    webAndApp,
}: SuccessLabels) => {
    const dataIcon = () => {
        if (webAndApp === true) {
            return (
                <>
                    <Icon src={android} alt={'android'} />

                    <Icon src={apple} alt={'apple'} />
                </>
            )
        } else if (webAndApp === false) {
            return <Icon src={web} alt={'web'} />
        } else {
            return (
                <>
                    <Icon src={android} alt={'android'} />

                    <Icon src={apple} alt={'apple'} />

                    <Icon src={web} alt={'web'} />
                </>
            )
        }
    }
    return (
        <OverCard
            paddingLeft={['small', 'small', 'xxsmall', 'small']}
            paddingRight={['small', 'small', 'xxsmall', 'small']}
            paddingBottom={'xxxmedium'}
        >
            <Card to={`/successStories/${title}`}>
                <HeaderCard>
                    <Image src={firstImage} alt={title} />
                </HeaderCard>
                <ContentData>
                    <TitleSection
                        variant={'h2'}
                        fontSize={'xmedium'}
                        fontWeight={700}
                    >
                        {title}
                    </TitleSection>
                    <ContentSection
                        variant={'h3'}
                        fontSize={'xxxsmall'}
                        fontWeight={500}
                    >
                        {functionality}
                    </ContentSection>
                    <ContentIcons
                        marginTop={'xxmedium'}
                        marginBottom={'xmedium'}
                    >
                        {dataIcon()}
                    </ContentIcons>
                </ContentData>
            </Card>
        </OverCard>
    )
}
